import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { Btn } from "../../../../AbstractElements";

const Reference = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Btn color={"secondary"}>{"Reference"}</Btn>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="up">
        <DropdownToggle color="secondary" className="light text-white">
          <i className="icofont icofont-arrow-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Action"}</DropdownItem>
          <DropdownItem href={Href}>{"Another action"}</DropdownItem>
          <DropdownItem href={Href}>{"Something else here"}</DropdownItem>
          <DropdownItem href={Href} divider></DropdownItem>
          <DropdownItem href={Href}>{"Separated link"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};

export default Reference;
